import { getWebPlaysDbLazy, ACTION_CARDS_STORE_NAME, ACTION_CARDS_STORE_INDEX_BY_PLAYBOOKS } from './dbService.js'

async function getStore(mode = 'readonly') {
  const db = await this.dbPromise
  return db.transaction(ACTION_CARDS_STORE_NAME, mode).objectStore(ACTION_CARDS_STORE_NAME)
}

async function remove(store, key) {
  const request = store.delete(key)
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve()
    request.onerror = () => reject(request.error)
  })
}

export class ActionCardsDbStore {
  constructor() {
    // Create a promise that resolves to the DB instance
    this.dbPromise = getWebPlaysDbLazy()
  }

  async get(key) {
    const store = await getStore.call(this, 'readwrite')
    const request = store.get(key)

    return new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result?.actionCardData)
      request.onerror = () => reject(request.error)
    })
  }

  async save(key, playbookId, actionCardData) {
    const store = await getStore.call(this, 'readwrite')

    playbookId = +(playbookId ?? 0)
    // make deep copy of action card data to exclude non clonable items like functions, etc.
    const record = { key, playbookId, actionCardData: JSON.parse(JSON.stringify(actionCardData)) }

    const request = store.put(record)
    return new Promise((resolve, reject) => {
      request.onsuccess = () => resolve()
      request.onerror = () => reject(request.error)
    })
  }

  async removeByPlaybook(playbookId) {
    playbookId = +(playbookId ?? 0)
    const store = await getStore.call(this, 'readwrite')
    const request = store.index(ACTION_CARDS_STORE_INDEX_BY_PLAYBOOKS).getAllKeys(playbookId)

    return new Promise((resolve, reject) => {
      request.onsuccess = async () => {
        const keys = request.result
        if (keys && keys.length > 0) {
          const removePromises = keys.map(key => remove(store, key))
          await Promise.all(removePromises)
          resolve()
        } else {
          resolve()
        }
      }

      request.onerror = () => reject(request.error)
    })
  }
}
